import { nav } from "@/store/interface/common";
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default () => {
  const store = useStore();
  const route = useRoute();
  const router = useRouter();
  const items = ref<nav[]>(store.getters.getNavArrCustomerManage);
  const getCustomerAuths = computed(() => store.getters.getCustomerAuths);
  const isDisabled = ref(false);

  watch(
    getCustomerAuths,
    async (newData) => {
      if (store.getters.getUserinfo("userType") != 1) {
        items.value.forEach((ite: any) => {
          if (ite.code == 100203) {
            if (!(newData.findIndex((m: any) => m.permissionCode == ite.code) > -1)) {
              ite.isHide = true;
              //如果没权限且在当前页则跳转到签约客户页
              if (route.name == "unsignedCustomer") {
                router.push({ name: "signedCustomer" });
              }
            } else {
              ite.isHide = false;
            }
          }
        });
      }
      await store.dispatch("setNavsCustomerManage", items);
    },
    { deep: true, immediate: true }
  );
  return { items, isDisabled };
};
